<template>
  <div v-if="!toggleable">
    <h2 class="dashboard-section__title">
      <span class="dashboard-section__suptitle">{{ suptitle }}</span>
      {{ title }}
    </h2>
    <slot></slot>
  </div>

  <div v-else class="dashboard-drawer" ref="drawer">
    <div class="dashboard-drawer__head" @click="toggleShowChildren" tabindex="0">
      <h2 class="dashboard-drawer__title">{{ title }}</h2>
      <span v-if="showCount" class="dashboard-drawer__count">
        {{ toggleableCount }}
        <span v-if="hasNotif" class="dashboard-drawer__notif"></span>
      </span>
      <span class="dashboard-drawer__arrow">
        <span :class="'arrow ' + (showChildren ? 'arrow__open' : '')" />
      </span>
    </div>

    <transition name="slide" @enter="enter" @leave="leave">
      <div ref="element" v-if="show">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    suptitle: {
      type: String,
      required: false
    },
    toggleable: Boolean,
    toggleableCount: {
      type: Number,
      require: false
    },
    hasNotif: Boolean
  },
  data() {
    return {
      showChildren: false
    }
  },
  mounted() {
    const observer = new MutationObserver(this.updateSectionHeight)
    observer.observe(this.$el, {
      childList: true,
      subtree: true
    })
    this.observer = observer
  },
  beforeUnmount() {
    this.observer.disconnect()
  },
  methods: {
    toggleShowChildren: function() {
      this.showChildren = !this.showChildren
    },
    updateSectionHeight: function() {
      if (this.show) {
        this.enter(this.$refs.element)
      }
    },
    enter: function(element) {
      if (element !== undefined) {
        element.style.maxHeight = `${element.firstChild.offsetHeight}px`
      }
    },
    leave: function(element) {
      if (element !== undefined) {
        element.style.maxHeight = 0
      }
    }
  },
  computed: {
    show: function() {
      return !this.toggleable || this.showChildren
    },
    showCount: function() {
      return this.toggleableCount !== undefined && this.toggleableCount !== null
    }
  }
}
</script>

<style lang="scss">
$font-size-h2: 50px !default;

.dashboard-section {
  &__title {
    margin-bottom: 24px;
  }
  &__suptitle {
    display: block;
    font-size: 16px;
    font-weight: 700;
    letter-spacing: 1px;
    line-height: 1.25;
    margin-bottom: 0;
    text-transform: uppercase;
  }
}

@media screen and (min-width: 768px) {
  .dashboard-section {
    &__title {
      max-width: calc(100% / 3 * 2);
    }
  }
}

.dashboard-drawer {
  & {
    margin: spacing('normal') 0;
  }

  &__head {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin: spacing('light') 0;
  }

  &__title {
    margin: 0 spacing('light') 0 0;
    font-size: calc(#{linear(24px, $font-size-h2)});
  }

  &__count {
    border-radius: 50%;
    background-color: color('primary');
    color: color('white');
    font-size: 24px;
    font-weight: bold;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: spacing('thin');
    position: relative;
    margin-left: auto;
    flex-shrink: 0;
  }

  &__notif {
    border-radius: 50%;
    background-color: color('warning');
    width: 14px;
    height: 14px;
    position: absolute;
    top: 0;
    right: 0;
  }
}

@media screen and (min-width: 768px) {
  .dashboard-drawer {
    &__title {
      max-width: calc(100% / 3 * 2);
      font-size: calc(#{linear(40px, $font-size-h2)});
    }
  }
}

.slide-enter-active {
  transition-duration: 0.3s;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to,
.slide-leave {
  overflow: hidden;
}

.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
</style>
